var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmonstrInstagram12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.892c2.267 0 4.107 1.839 4.107 4.108 0 2.269-1.839 4.108-4.108 4.108-2.268 0-4.108-1.839-4.108-4.108 0-2.269 1.84-4.108 4.108-4.108zm0 1.441C6.525 5.333 5.331 6.527 5.331 8c0 1.474 1.194 2.667 2.667 2.667 1.473 0 2.667-1.194 2.667-2.667 0-1.473-1.194-2.667-2.667-2.667zM13.23 3.73c0-.53-.43-.96-.96-.96s-.96.43-.96.96.43.96.96.96.96-.43.96-.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.939 0c1.34.004 1.647.016 2.36.049C14.205.182 15.82 1.8 15.95 4.702 15.991 5.555 16 5.828 16 8v.262c0 1.935-.01 2.219-.048 3.036-.13 2.909-1.75 4.521-4.653 4.654-.854.039-1.126.048-3.299.048s-2.444-.009-3.298-.048c-2.908-.133-4.52-1.748-4.654-4.654-.03-.675-.043-.986-.046-2.165V6.867c.003-1.178.015-1.49.046-2.166C.181 1.793 1.795.181 4.701.048 5.413.015 5.72.004 7.06.001zm-.017 1.443H7.077c-1.315.003-1.608.013-2.31.046-2.17.098-3.18 1.127-3.28 3.279-.032.703-.043.995-.046 2.31v1.845c.003 1.314.015 1.607.047 2.311.098 2.147 1.105 3.18 3.28 3.279.841.038 1.095.046 3.231.046 2.137 0 2.39-.009 3.234-.047 2.17-.098 3.18-1.129 3.28-3.279.037-.844.045-1.097.045-3.233v-.257c0-1.901-.01-2.167-.046-2.975-.1-2.152-1.112-3.181-3.28-3.28-.702-.032-.996-.042-2.31-.045z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmonstrInstagram12);
export default __webpack_public_path__ + "static/media/iconmonstr-instagram-12.63a3c7dbd34337ed42fd796ab7ba58b7.svg";
export { ForwardRef as ReactComponent };